var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.libraryType)?_c('div',{staticClass:"library"},[(_vm.detailId)?[(_vm.libraryType === _vm.LIBRARY_TYPE.STYLE)?_c('DetailStyle',{attrs:{"item-id":_vm.detailId},on:{"close":_vm.closeDetail}}):_vm._e()]:_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }